/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['../selector'], function(selector) {
    'use strict';
    return function(json) {
        return selector(json, 'results', 'address, dist, position, score, entryPoints,' +
            ' type, addressRanges, boundingBox, viewport, id, info, dataSources, entityType') || {};
    };
});



// WEBPACK FOOTER //
// ./model/geocode/geocode.js